import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { onSuccess, useApiMutation } from "../utils/api";
import { useNavigate } from "react-router-dom";

export const CreateProjectModal = ({
  onClose,
  refetch,
}: {
  onClose: () => void;
  refetch: () => void;
}) => {
  const [name, setName] = useState("");
  const { post } = useApiMutation();
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name.trim()) {
      post("/api/user/create_board", { name: name.trim() }).then(
        onSuccess((data) => {
          refetch();
          onClose();
          navigate(`/boards/${data.id}`);
        })
      );
    }
  };

  return (
    <Modal show={true} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create New Board</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Board name"
              autoFocus
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Create Board
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
